import { cva, VariantProps } from "cva";
import styles from "./RadioButton.module.css";

export const radioButtonStyles = cva({
  base: styles.radio,
  variants: {
    fontWeight: {
      regular: styles.regular,
      bold: styles.bold,
    },
    radioIconPosition: {
      insetInlineStart: styles.iconLeft,
      insetInlineEnd: styles.iconRight,
    },
  },
  defaultVariants: {
    fontWeight: "bold",
    radioIconPosition: "insetInlineStart",
  },
});

export type RadioButtonRecipeProps = VariantProps<typeof radioButtonStyles>;
